import { IntakeLabelCollection } from '../../entities/intake-label.interface';

export const IesIncomeLabels: IntakeLabelCollection = {
  incomeType: {
    label: 'Income type (average monthly net)',
  },
  personal: {
    label: 'Personal',
    thirdPersonLabel: '<<applicantName>>',
  },
  spouse: {
    label: 'Spouse/Partner',
    thirdPersonLabel: '<<spouseName>>',
  },
};
